import { Action } from '@ngrx/store';
import { IBrandData } from "../models/IBrandData";

export enum ActionTypes {
    SET_BRANDS = '[Brands] SET_BRANDS',
    SET_ERROR = '[Brands] Set Error',
}

export class SetBrandsAction implements Action {
  readonly type = ActionTypes.SET_BRANDS;
  constructor(public payload: IBrandData[]) { }
}

export class SetErrorAction implements Action {
    readonly type = ActionTypes.SET_ERROR;
    constructor(public payload: { error: string }) { }
  }

export type Actions = SetBrandsAction | SetErrorAction;
